import axios from 'axios'
import store from '@/store'

const API_BASE_URL = process.env.VUE_APP_API_URL || 'https://clubtest.intrare.app'

function getHeaders () {
  return {
    'Content-Type': 'application/json',
    'Authorization': `Token ${store.getters.getToken}`
  }
}

export const tournamentsAPI = {
  list (params) {
    return axios.get(`${API_BASE_URL}/tournaments/`, {
      headers: getHeaders(),
      params
    })
  },

  get (id) {
    return axios.get(`${API_BASE_URL}/tournaments/${id}/`, {
      headers: getHeaders()
    })
  },

  create (data) {
    return axios.post(`${API_BASE_URL}/tournaments/`, data, {
      headers: getHeaders()
    })
  },

  update (id, data) {
    return axios.patch(`${API_BASE_URL}/tournaments/${id}/`, data, {
      headers: getHeaders()
    })
  },

  delete (id) {
    return axios.delete(`${API_BASE_URL}/tournaments/${id}/`, {
      headers: getHeaders()
    })
  },

  register (tournamentId, data) {
    return axios.post(
      `${API_BASE_URL}/tournaments/${tournamentId}/register_player/`,
      data,
      { headers: getHeaders() }
    )
  },

  // Admin/RP: usuario (user_id), socio CCSLP (ccslp_user_id) o invitado (guest_*)
  // se inscriben por un único endpoint
  registerByAdmin (tournamentId, data) {
    return axios.post(
      `${API_BASE_URL}/tournaments/${tournamentId}/inscribir-user/`,
      data,
      { headers: getHeaders() }
    )
  },

  registerCCSLPUser (tournamentId, data) {
    return axios.post(
      `${API_BASE_URL}/tournaments/${tournamentId}/inscribir-user/`,
      data,
      { headers: getHeaders() }
    )
  },

  registerGuest (tournamentId, data) {
    return axios.post(
      `${API_BASE_URL}/tournaments/${tournamentId}/inscribir-user/`,
      data,
      { headers: getHeaders() }
    )
  },

  getRegistrations (tournamentId) {
    return axios.get(
      `${API_BASE_URL}/tournaments/${tournamentId}/registrations/`,
      { headers: getHeaders() }
    )
  },

  cancelRegistration (registrationId) {
    return axios.post(
      `${API_BASE_URL}/tournament-registrations/${registrationId}/cancel/`,
      {},
      { headers: getHeaders() }
    )
  },

  myRegistrations (params) {
    return axios.get(`${API_BASE_URL}/tournament-registrations/`, {
      headers: getHeaders(),
      params: { mine: true, ...params }
    })
  },

  // ---- Imagen del torneo (Admin/RP, opcional) ----
  uploadImage (tournamentId, file) {
    const form = new FormData()
    form.append('image', file)
    return axios.post(`${API_BASE_URL}/tournaments/${tournamentId}/image/`, form, {
      headers: { 'Authorization': `Token ${store.getters.getToken}` }
    })
  },

  removeImage (tournamentId) {
    return axios.delete(`${API_BASE_URL}/tournaments/${tournamentId}/image/`, {
      headers: getHeaders()
    })
  },

  // ---- Participantes del torneo (Admin/RP) ----
  members (tournamentId, params) {
    return axios.get(`${API_BASE_URL}/tournaments/${tournamentId}/members/`, {
      headers: getHeaders(),
      params
    })
  },

  stats (tournamentId) {
    return axios.get(`${API_BASE_URL}/tournaments/${tournamentId}/stats/`, {
      headers: getHeaders()
    })
  },

  importMembers (tournamentId, file, dryRun = false) {
    const form = new FormData()
    form.append('file', file)
    form.append('dry_run', dryRun ? 'true' : 'false')
    return axios.post(`${API_BASE_URL}/tournaments/${tournamentId}/import-members/`, form, {
      headers: { 'Authorization': `Token ${store.getters.getToken}` }
    })
  },

  // Envía un lote de invitaciones pendientes; repetir mientras remaining > 0
  sendInvitations (tournamentId, data = {}) {
    return axios.post(
      `${API_BASE_URL}/tournaments/${tournamentId}/send-invitations/`,
      data,
      { headers: getHeaders() }
    )
  },

  // Reenvío manual a un participante: channels = ['whatsapp'] | ['email'] | undefined (todos)
  resendMember (memberId, channels) {
    return axios.post(
      `${API_BASE_URL}/temp-tournament-members/${memberId}/resend/`,
      channels ? { channels } : {},
      { headers: getHeaders() }
    )
  },

  // Da de baja (cancela) a un participante; no elimina su información
  cancelMember (memberId) {
    return axios.delete(`${API_BASE_URL}/temp-tournament-members/${memberId}/`, {
      headers: getHeaders()
    })
  },

  markAttended (memberId) {
    return axios.post(
      `${API_BASE_URL}/temp-tournament-members/${memberId}/mark-attended/`,
      {},
      { headers: getHeaders() }
    )
  }
}
